// Func = limiting Scope for this file
var lastScrollTop = 0;
(function () {
	// SPECIALS MODAL CLOSE BUTTON, LIKE THE BOOKING ONE
	if ($.fancybox) {
		$.fancybox.defaults.btnTpl.smallBtn = `<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M 12 0 V 24" />
                    <path d="M 0 12 H 24" />
                </svg>
            </button>`;
	}

	$(document).ready(function () {
		// HOME MAP
		document.querySelectorAll('.locationMod').forEach((mod) => {
			mod.querySelectorAll('[data-ref*="item"]').forEach((btn) => {
				btn.addEventListener('click', () => {
					mod.querySelectorAll('[data-ref*="item"]').forEach((bt) => bt.classList.remove('active'));
					mod.querySelectorAll(`[data-ref="${btn.dataset.ref}"]`).forEach((item) => item.classList.add('active'));
				});
			});

			// MAP INTRO
			mod.querySelectorAll('[data-ref="item-intro"]').forEach((btn) => {
				btn.addEventListener('mouseenter', () => {
					mod.querySelectorAll('[data-ref*="item"]').forEach((bt) => bt.classList.remove('active'));
					mod.querySelectorAll(`[data-ref="item-intro"]`).forEach((item) => item.classList.add('active'));
				});
			});
		});

		// TOGGLE MAIN NAV
		document.querySelectorAll('.js-toggleNav').forEach((btn) => {
			btn.addEventListener('click', (e) => {
				e.preventDefault();

				const navID = btn.getAttribute('href');
				if (document.querySelector(navID)) {
					btn.classList.toggle('active');

					document.querySelector(navID).classList.toggle('active');
					document.body.classList.toggle('noscroll', document.querySelector(navID).classList.contains('active'));
				}
			});
		});

		// Main Nav Dropdown
		$('#primary-nav li').hover(
			function () {
				$(this).addClass('hover');
				$('ul.submenu', this).fadeIn(200);
			},
			function () {
				$(this).removeClass('hover');
				$('ul.submenu', this).fadeOut(200);
			}
		);

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date) {
			let d1 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn').val());
			let d2 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut').val());
			if ((d1 && date.getTime() == d1.getTime()) || (d2 && date.getTime() == d2.getTime())) {
				DATE_STYLE[1] = 'highlight-top';
			} else if (date > d1 && date < d2) {
				DATE_STYLE[1] = 'highlight';
			} else {
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = $('#CheckIn').data('format') !== undefined && $('#CheckIn').data('format') ? $('#CheckIn').data('format') : 'yy-mm-dd';
		$('#CheckIn').datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			dateFormat: DATE_FORMAT,
			numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$('#CheckOut').datepicker('setDate', newDate);
				$('#CheckOut').datepicker('option', 'minDate', selectedDate);
			},
		});
		$('#CheckOut').datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			dateFormat: DATE_FORMAT,
			changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			},
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

		//webhook for datepicker
		if ($('#form_id-1357').length != 0) {
			$('input[name=arrival_date]').datepicker('destroy');
			$('input[name=arrival_date]').datepicker({
				onSelect: function (selectedDate) {
					$('input[name=departure_date]').datepicker('option', 'minDate', selectedDate);
					setTimeout(function () {
						$('input[name=departure_date]').datepicker('show');
					}, 16);
				},
			});
		}
	});

	window.onload = function () {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function () {
			scrollW();
		});
	};
})();

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
